/* eslint-disable camelcase */
export const ITEMS_PER_PAGE = 5;
export const EMAIL_VALIDATION_REGEX = /\S+@\S+\.\S+/;
export const FORGOT_PASSWORD_CODE_LENGHT = 6;
export const FORGOT_PASSWORD_CODE_LENGTH = 6;
